import React from 'react';
import { Col, message } from 'antd';
import { useNavigate } from 'react-router-dom'; // Add this import
import authService from '../../services/auth.service';
import { notifySuccess } from '../../utils/notification';
import { AppRoutes } from '../../enums';

export default function SignUpFollowupPage(props) {
	const navigate = useNavigate(); // Add this line

	// Check if the user is not logged in and redirect to the sign-in page
	if (!authService.isAuthenticated()) {
		navigate(AppRoutes.SIGNIN);
		return null;
	}

	return (
		<div className="bg-overlay-dark">
			<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
				<Col xs={20} md={10}>
					<div className="p-4 mt-0" style={{ backgroundColor: '#ffffff', borderRadius: '10px' }}>
						<p className="text-head--lg mt-5 text-center">
							You've successfully signed up. Check your email for the verification link.
						</p>
						<p className="text-center">
							If the email didn't arrive shortly, try{' '}
							<a
								href="/activate"
								onClick={async e => {
									e.preventDefault();
									try {
										await authService.resendConfirmation();
										notifySuccess('Confirmation email has been sent');
									} catch (e: any) {
										message.error(e.message);
										console.error(e);
									}
								}}
							>
								resend
							</a>
						</p>
					</div>
				</Col>
			</div>
		</div>
	);
}
